var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { INLINE_STYLES } from '../helper';
var IconS24MapMagnifier48 = function (_a) {
    var inline = _a.inline, title = _a.title, rest = __rest(_a, ["inline", "title"]);
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 32 32", fill: "currentColor" }, rest, { style: __assign(__assign({}, (inline && INLINE_STYLES)), rest.style) }),
        title && React.createElement("title", null, title),
        React.createElement("path", { d: "M10.667 15.333c-2.942 0.005-5.324 2.391-5.324 5.333 0 1.236 0.421 2.374 1.126 3.279l-0.009-0.012-3.793 3.793 0.94 0.94 3.793-3.793c0.888 0.702 2.025 1.127 3.26 1.127 0.002 0 0.005 0 0.007 0h-0c2.946 0 5.333-2.388 5.333-5.333s-2.388-5.333-5.333-5.333v0zM10.667 24.667c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4v0c0 2.209-1.791 4-4 4v0z" }),
        React.createElement("path", { d: "M28 26.873l-6.667-3.333v-18.347l6.667 3.333zM13.333 28.333l7.333-3.667 8 4h0.667v-20.973l-8.667-4.36-8 4-8-4h-0.667v12.408l1.333-0.667v-9.881l6.667 3.333v4.807l1.333-0.667v-4.14l6.667-3.333v18.347l-6.667 3.333z" })));
};
export default IconS24MapMagnifier48;
//# sourceMappingURL=IconS24MapMagnifier48.js.map